import { CustomExtender } from '#/CoreFrameInterfaces';

export default class WaiterExtender implements CustomExtender {

    public AddToKnockout() {
        ko.extenders.waiter = (target, timeout) => {
            let timer = null;
            let currentValue = target();
            let interceptor: any;
            
            if (ko.isComputed(target) && !ko.isWriteableObservable(target)) {
                let constructor = target["push"] != null ? 'observableArray' : 'observable';
                interceptor = ko[constructor](currentValue).extend({ waiter: timeout });
            }

            if (interceptor != null)
            {
                target.subscribe(interceptor);
                return interceptor;
            }            

            return ko.computed({
                read: target,
                write: (value) => {
                    if (timer != null) {
                        window.clearTimeout(timer);
                    }

                    timer = window.setTimeout(() => {
                        target(value);
                    }, timeout);
                }
            });
        };
    }

};